import React from 'react'

import { useSelector } from 'react-redux'
import { RootState } from 'slices'

import { IxConfirmPopup } from 'components/confirm-popup'
import {useTranslation} from 'react-i18next'

export const IxGlobalConfirmPopup = () => {
    const { t } = useTranslation()
    const { open, title, description, onConfirm, onHiding, confirm, cancel } = useSelector((state: RootState) => state.cPopupSlice)

    return (
        <IxConfirmPopup
            popupVisible={ open }
            title={ title }
            description={ description }
            cancel={ cancel || t('global:button.no') }
            confirm={ confirm || t('global:button.yes') }
            onConfirm={ onConfirm }
            onHiding={ onHiding }
        />
    )
}
